import { collection, doc, onSnapshot } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { defaultCategories } from "../constants";
import { CustomerTicketAnalytics } from "../types";

export const getCustomerTicketsAnalytics = (
  callback: (data: CustomerTicketAnalytics) => void,
) => {
  const collectionRef = collection(db, `statistics`);
  const docRef = doc(collectionRef, "customerSupportTickets");

  return onSnapshot(docRef, (snapshot) => {
    const data = snapshot.data()!;

    callback({
      lastWeekTotalInquiries: data.lastWeekTotalInquiries || 0,
      thisWeekTotalInquiries: data.thisWeekTotalInquiries || 0,
      weeklyDifferencePercentage: data.weeklyDifferencePercentage || 0,
      thisWeekAverageResponseTime: data.thisWeekAverageResponseTime || 0,
      lastWeekAverageResponseTime: data.lastWeekAverageResponseTime || 0,
      inquiriesByCategory: defaultCategories.map((category) => {
        const matchingCategory = data.inquiriesByCategory?.find(
          (item: { category: string }) => item.category === category,
        );
        return {
          category,
          thisWeekCount: matchingCategory?.thisWeekCount || 0,
          lastWeekCount: matchingCategory?.lastWeekCount || 0,
          weeklyPercentageDifference:
            matchingCategory?.weeklyPercentageDifference || 0,
        };
      }),
      weeklyResponseTimeDifferencePercentage:
        data.weeklyResponseTimeDifferencePercentage || 0,
    });
  });
};
